import { BazaarVoiceReviewsQuestions } from './BazaarVoiceReviewsQuestions';

export default function BazaarVoiceReviewsQuestionsComponent() {
  return <BazaarVoiceReviewsQuestions />;
}
